export { heroEmailSchema } from "@/lib/form-schemas";

export type Seg = { text: string; color: string };
export type Line = Seg[];

export const FG = "var(--foreground)";
export const DIM = "var(--muted-foreground)";
export const KEYWORD = "color-mix(in srgb, var(--foreground) 85%, transparent)";
export const CODE_GREEN = "var(--code-green)";

export const STAGGER_MS = 85;
export const PLACEHOLDER_FULL = "you@company.com";

export function buildLines(username: string): Line[] {
  const u = username || "your@email.com";
  const uColor = username ? CODE_GREEN : DIM;

  return [
    [
      { text: "import", color: KEYWORD },
      { text: " requests", color: FG },
    ],
    [],
    [{ text: "# Proxidize quickstart", color: DIM }],
    [
      { text: "USERNAME", color: FG },
      { text: " = ", color: DIM },
      { text: `"${u}"`, color: uColor },
    ],
    [
      { text: "PASSWORD", color: FG },
      { text: " = ", color: DIM },
      { text: '"your_password"', color: DIM },
    ],
    [
      { text: "ENDPOINT", color: FG },
      { text: " = ", color: DIM },
      { text: '"gate.proxidize.com:7777"', color: CODE_GREEN },
    ],
    [],
    [
      { text: "proxy_url", color: FG },
      { text: " = ", color: DIM },
      { text: 'f"http://{USERNAME}:{PASSWORD}@{ENDPOINT}"', color: CODE_GREEN },
    ],
    [],
    [
      { text: "response", color: FG },
      { text: " = requests.get(", color: DIM },
    ],
    [
      { text: '    "https://api.ipify.org"', color: CODE_GREEN },
      { text: ",", color: DIM },
    ],
    [
      { text: "    proxies", color: FG },
      { text: '={"https": proxy_url},', color: DIM },
    ],
    [{ text: ")", color: DIM }],
    [],
    [
      { text: "print", color: KEYWORD },
      { text: "(response.json())", color: DIM },
      { text: '  # → {"ip":"104.28.x.x"}', color: DIM },
    ],
  ];
}

export const containerVariants = {
  hidden: {},
  visible: { transition: { staggerChildren: 0.1 } },
};

export const itemVariants = {
  hidden: { opacity: 0, y: 16 },
  visible: { opacity: 1, y: 0, transition: { duration: 0.5 } },
};
